import { atom, computed } from 'nanostores';
import { detectBrowser } from '~/utils/detectBrowser';

const DISMISS_KEY = 'incompatible-env-dismiss';

class CompatibleEnvStore {
  isChromium = atom(false);
  isDismissed = atom(false);

  shouldShow = computed([this.isDismissed, this.isChromium], (dismissed, isChromium) => !isChromium && !dismissed);

  checkCompatability(): void {
    const isDismissed = !!sessionStorage.getItem(DISMISS_KEY);

    this.isChromium.set(detectBrowser(navigator.userAgent).browserName === 'Chrome');
    this.isDismissed.set(isDismissed);

    this.isDismissed.subscribe((value) => {
      if (value) {
        sessionStorage.setItem(DISMISS_KEY, new Date().toISOString());
      }
    });
  }

  dismiss(): void {
    this.isDismissed.set(true);
  }
}

export const compatibleEnvStore = new CompatibleEnvStore();
